import type { ReactNode } from "react";

import { Navigate } from "@libs/router";
import { StorageService } from "@libs/storage-service";

function readAccessToken(): string | null {
  try {
    return StorageService.get<string>("accessToken");
  } catch {
    return null;
  }
}

type GuestRouteProps = {
  children: ReactNode;
};

export const GuestRoute = ({ children }: GuestRouteProps) => {
  const accessToken = readAccessToken();
  const isAuthenticated = Boolean(accessToken);

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};
